<div class="modal" [ngStyle]="{'display': visible}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-backdrop fade in" style="height: 2607px;"></div>
  <div class="modal-dialog">
    <div class="modal-content" style="margin-top: 190px">
      <div class="modal-body">
        <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-user-times" style="color:var(--secondary-btn-bg-color);"></i> {{ 'removeTimeSlot' | translate }}</h3>
        <button (click)="cancel()" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" style="background: var(--secondary-btn-bg-color);float: right;margin-top: -3em;margin-right: -2em;border: none;" type="button">×</button>
        <div class="col-md-3" style="width: 150px;min-height: 150px;margin: 0 auto;">
          <img src="{{staffImage}}" id="staffimageforttimetble" style="margin-top: 43px;height: 80px;width: 80px;" class="img-responsive">
        </div>
        <!--<div class="col-md-9">-->
        <p [innerHtml]="fullMessageHTMLString" style="font-size: 19px;margin-left: 6px;padding: 29px 30px;"></p>
        <!--</div>-->
        <p style="margin-top: -2em;font-size: 19px;margin-left: 99px;padding: 29px 30px;">{{ 'doYouWantToClear' | translate }} <span class="text-bold">{{showTimeSlot}}</span> {{ 'periodIn' | translate }} <span class="text-bold">{{showClass}}</span>?</p>
        <div style="padding:0px 205px;margin-top: -12px;">
          <button (click)="removeTimeSlot()" class="btn btn-info btn-sm" style="width: 67px;">{{ 'yes' | translate }}</button>
          <button (click)="cancel()" class="btn btn-info btn-sm" data-dismiss="modal">{{ 'cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
